import { ExtendedButtonProps } from "@components/general/Button/Button";
import { forwardRef, useMemo } from "react";
import { NavigationDropdownToggle } from "@components/general/NavigationDropdownToggle/NavigationDropdownToggle";
import { useUser } from "@hooks/useUser";

const MAX_NAME_LENGTH = 13;

export const PersonalViewNavigationDropdownToggle: React.FC<ExtendedButtonProps> =
    forwardRef(({ onClick }, ref) => {
        const user = useUser();

        const shortName = useMemo(
            () => user.name.slice(0, MAX_NAME_LENGTH),
            [user.name],
        );

        return (
            <NavigationDropdownToggle onClick={onClick} ref={ref as any}>
                {shortName}
            </NavigationDropdownToggle>
        );
    });
